import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import {EuiFlexGroup, EuiFlexItem, EuiPanel, EuiSwitch, EuiButtonIcon, EuiTitle, 
  EuiLoadingSpinner, EuiIcon, EuiFilterGroup,EuiFilterButton, EuiPopover} from '@elastic/eui';
import moment from 'moment';
import { Menu } from '../../../../components/Menus';
import { Action } from '../../../../components/Menus/interface';
import { SelectorInformesContainer as SelectorInformes } from '../../../../components/Selectores/Informes/container';
import { SelectorMonedasContainer as SelectorMonedas} from '../../../../components/Selectores/Monedas/container';
import { GridResultsScreen } from '../../../../components/GridInformes/GridResultsScreen';
import { SumarigramaContainer } from '../../../Consultas/Sumarigrama/Screen';
import './styles.css';
import { TablaInforme } from '../../../../components/TablaInforme';
import { GraficoInforme } from '../../../../components/GraficoInforme';
import { GraficosBarras } from '../../../../components/GraficosBarras';
import html2canvas from 'html2canvas';
import {downloadPDF, openPDF, asyncdownloadPDF} from '../../../../../../shared/Components/Pdf';
import informePdf from '../../../../components/Report'
import { TITLESREPORT } from './constant';
import { useUserSettings } from "../../../../context/CurrentUserContext";
import logopdf from '../../../../../../shared/Icons/logoInfraestructura.png';
import { InformesDetalleAdapter } from '../../../../../../infraestructure/persistence/rest/InformesDetalleAdapter';

interface dataRequest {año:number, periodo:number, IdTipoInforme: string, MonedaCorriente: boolean, moneda: string, IdCentroDesde: string}
interface dataMostrarOcultarRequest {año:number, periodo:number, IdTipoInforme: string, IdCentroInforme: string, IdCentro: string, IdPais: string, NoMostrar: boolean, MonedaCorriente: boolean, moneda: string}
interface dataSubirBajarRequest {año:number, periodo:number, IdTipoInforme: string, IdCentroInforme: string, IdCentro: string, SubirCentro: boolean, MonedaCorriente: boolean, moneda: string}

interface Props {
  onFilter(data: dataRequest): void;
  data: any;
  año: any;
  periodo: any;
  reunion: any;
  isLoading: boolean;
  onMostrarOcultarClick(data: dataMostrarOcultarRequest): void;
  onSubirBajarClick(data: dataSubirBajarRequest): void;
  onOtroFormatoClick(data: dataMostrarOcultarRequest): void;
  onLabelBottomClick(data: any): void;
  onClearData(): void;
}

const toDataUrl = async(file:any,callback?:any) =>{
  var xhr = new XMLHttpRequest();
     xhr.responseType = 'blob';
     xhr.onload = function() {
    var reader = new FileReader();
    reader.onloadend = function() {
     callback(reader.result);
  }
    reader.readAsDataURL(xhr.response);
 };
  xhr.open('GET', file);
  xhr.send();
  }

export const SeleccionInformesScreen = (props: Props) => {

  const { currentUser }:any = useUserSettings() as any;

  let { onFilter, data, año, periodo, reunion, isLoading, onMostrarOcultarClick, onSubirBajarClick, onOtroFormatoClick, onLabelBottomClick, onClearData } = props;
  const ref:any = useRef();
  
  const _año = parseInt(moment().format('M')) === 1 ? parseInt(moment().format('Y'))-1 : parseInt(moment().format('Y'));
  const _tiposMoneda = [{label:'Moneda Corriente',value:'MCR'}, {label:'Moneda Constante',value:'MCT'}]

  let [informe, setInforme] = useState<any>(undefined);  
  let [versionInforme, setversionInforme] = useState<any>(undefined);
  let [moneda, setMoneda] = useState<any>('EUR');
  let [sinAño, setSinAño] = useState<boolean>(true);
  let [idCentro, setIdCentro] = useState<any>(undefined);
  let [showGrid, setShowGrid] = useState<boolean>(false);
  let [toogle, setToogle] = useState(false);
  let [isPrinting, setIsPrinting] = useState<boolean>(false);
  let [tipoCambioMoneda, setTipoCambioMoneda] = useState(_tiposMoneda[0].value)
  let [ocultarSuc, setOcultarSuc] = useState<any>({name:'suc', value:false});
  let [ocultarFil, setOcultarFil] = useState<any>({name:'fil', value:false});
  let [ocultarUte, setOcultarUte] = useState<any>({name:'ute', value:false});
  let [ocultarElec, setOcultarElec] = useState<any>({name:'elec', value:false});
  let [todosInformes, setTodosInformes] = useState<any>([]);
  let [informeEnImpresion, setInformesEnImpresion] = useState<any>([]);
  let [imprimiendoInforme, setImprimiendoInforme] =useState<any>(0);
  let [descargaIniciada, setDescargaIniciada] = useState<boolean>(false);
  let [ocultarBorrador, setOcultarBorrador] = useState<boolean>(false);
  let logo:any = undefined;
  const [openConfiguration, setOpenConfiguration] = useState(false);
  let [ultInformeImpreso, setUltInformeImpreso] =useState<any>(0);
  let [informeImpresionIni, setInformeImpresionIni] =useState<any>(undefined);
  let [verAnimation, setVerAnimation] = useState<boolean>(true);

  useEffect(()=>{
    setSinAño(año === undefined);
  },[año]);

  const tieneNoValidados = useMemo(()=>{
    return data!==undefined ? data.filter((x: any) => x.validado == false).length > 0 : false;
  },[data])

  useEffect(()=>{
    if(data.length > 0 && informeEnImpresion.length > 0 && imprimiendoInforme > 0){
      if(descargaIniciada){
        if(imprimiendoInforme < todosInformes.length){ 
          console.log('imprimirInforme IF ultInformeImpreso', ultInformeImpreso);
          console.log('imprimirInforme IF imprimiendoInforme -1',imprimiendoInforme -1);
            if(ultInformeImpreso == imprimiendoInforme -1){
          setTimeout(()=>{
            console.log('imprimirInforme IF', todosInformes[imprimiendoInforme].tipoInforme);
            setInforme(todosInformes[imprimiendoInforme].idTipoInforme);
            setversionInforme(todosInformes[imprimiendoInforme-1].idVersion);
            const reqdata : dataRequest = {
              año : año, periodo: periodo, IdTipoInforme: todosInformes[imprimiendoInforme].idTipoInforme, MonedaCorriente: tipoCambioMoneda == 'MCR', moneda: moneda[0].value, IdCentroDesde: idCentro
            }
            setDescargaIniciada(false);
            onFilter(reqdata);
            setImprimiendoInforme(imprimiendoInforme + 1);
            setVerAnimation(false);
          },500)}          
        }else{
          setTimeout(()=>{
            console.log('imprimirInforme ELSE');
            setInforme('TODO')
            setversionInforme(undefined)
            setImprimiendoInforme(0)
            setUltInformeImpreso(0);
            setInformesEnImpresion([])
            setDescargaIniciada(false);
            setInformeImpresionIni(undefined);
            onClearData()
            setVerAnimation(true);
          },500)
        }
      }
      console.log('imprimirInforme useEffect', informe);
      setTimeout(()=>{
        console.log('imprimirInforme setTimeout', todosInformes[imprimiendoInforme -1].tipoInforme);
        console.log('imprimirInforme ult ult', ultInformeImpreso);
        console.log('imprimirInforme ult imp', imprimiendoInforme -1);
        if(ultInformeImpreso == imprimiendoInforme -1){
          console.log('imprimirInforme ult imprimir', imprimiendoInforme -1);
          if(imprimiendoInforme -1 != informeImpresionIni){
            setInformeImpresionIni(imprimiendoInforme -1);
            imprimirInforme(todosInformes[imprimiendoInforme -1].tipoInforme).then(()=>{
              console.log('imprimirInforme THEN', todosInformes[imprimiendoInforme -1].tipoInforme);
            })
          }
        }
      },informe.startsWith('GR') ? 3000 : 200);
    }
  },[data, imprimiendoInforme, informeEnImpresion, descargaIniciada, ultInformeImpreso]);

  const onInformeChange = (value: any) => {
    if(value != undefined){
      if(Array.isArray(value)){
        setInforme('TODO')
        setversionInforme(null)
        setTodosInformes(value);
        setDescargaIniciada(false);
        onClearData()
      }else{
        setInforme(value.idTipoInforme);
        setversionInforme(value.idVersion);
        setTodosInformes([]);
      }
    }
  }

  const onRefresh = () =>{
    onFilter(getRequesData());
  }

  const getRequesData = () => {
    const reqdata : dataRequest = {
      año : año, periodo: periodo, IdTipoInforme: informe, MonedaCorriente: tipoCambioMoneda == 'MCR', moneda: moneda[0].value, IdCentroDesde: idCentro
    }
    return (
      reqdata
    )
  }

  const onClickToogle = () =>{
    setToogle(!toogle)
  }

  const getFilter = useMemo(()=> {return{'año':año, 'periodo':periodo, 'idTipoContenido':informe}},[año,periodo,informe])

  const onClickCentro = (id:string)=> setIdCentro(id)

  const fnIsLoading = (pisLoading: boolean, psinAño: boolean) =>{
    if(pisLoading)
      return <EuiLoadingSpinner size="xl" />
    else
      return <EuiButtonIcon iconSize='s' display="fill" iconType="refresh" aria-label="Recargar" onClick={()=> onRefresh()} isDisabled={psinAño || todosInformes.length > 0} />
  }

  const onClickPrint = async() => {
    if(todosInformes.length > 0){
      console.log('todos Informes', todosInformes);
      setVerAnimation(false);
      // alert('TODOS')
      setDescargaIniciada(false);
      setInformesEnImpresion([...todosInformes]);
      setInforme(todosInformes[0].idTipoInforme);
      setversionInforme(todosInformes[0].idVersion);
      const reqdata : dataRequest = {
        año : año, periodo: periodo, IdTipoInforme: todosInformes[0].idTipoInforme, MonedaCorriente: tipoCambioMoneda == 'MCR', moneda: moneda[0].value, IdCentroDesde: idCentro
      }
      onFilter(reqdata);
      setImprimiendoInforme(1);
      // var informes = [...todosInformes];
      // informes.forEach((value, index)=>{
      //   console.log(value);
      //   setTimeout(()=>{
      //     setInforme(value.idTipoInforme);
      //     setversionInforme(value.idVersion);
      //     const reqdata : dataRequest = {
      //       año : año, periodo: periodo, IdTipoInforme: value.idTipoInforme, MonedaCorriente: tipoCambioMoneda == 'MCR', moneda: moneda[0].value, IdCentroDesde: idCentro
      //     }
      //     onFilter(reqdata);
      //   }, 12000 * index);        
      // });
    }else{
      setVerAnimation(true);
      imprimirInforme('');
    }
  }

  const imprimirInforme = async(pInforme: any) => {
    var obj:any = document.getElementById('AreaImprimirPDF') ?? document.createElement("div");
    obj && obj.parentElement &&  (obj.parentElement.scrollTop = 0);

    await toDataUrl(logopdf,(base64Image:any)=> {logo = base64Image})

    html2canvas(obj, {
        height: obj.scrollHeight,
        width: obj.scrollWidth,
        scale: 3,
        backgroundColor: null,
        logging: false,
        
      }).then((canvas) => {
            var vImg = canvas.toDataURL();            
            var vTitle = getTitle;
            console.log('funcion imprimirInforme informeEnImpresion ', informeEnImpresion)
            console.log('funcion imprimirInforme imprimiendoInforme ', imprimiendoInforme)
            if(informeEnImpresion.length > 0 && imprimiendoInforme > 0) {
              // downloadPDF
              asyncdownloadPDF(informePdf(vImg, informe, vTitle, logo, (año + ' - ' + reunion)),vTitle + '_' + pInforme + '.pdf', setDescargaIniciada, setUltInformeImpreso, imprimiendoInforme).then(()=>{
              console.log("imprimirInforme asyncdownloadPDF", vTitle + '_' + pInforme + '.pdf')
              // setDescargaIniciada(true);
              })
            }
            else openPDF(informePdf(vImg, informe, vTitle, logo, (año + ' - ' + reunion)));
            setIsPrinting(false);
      });
  }

  const onImageDownload = async() => {

    // var obj:any = document.getElementById('AreaImprimirPDF') ?? document.createElement("div");
    // obj && (obj.parentElement.scrollTop = 0);

    var objTable:any = document.getElementById('AreaImprimirPDF') ?? document.createElement("div");
    var objTitle = document.getElementById('AreaImprimirIMG') ?? document.createElement("div");
    let newDiv = document.createElement("div");

    objTable && (objTable.parentElement.scrollTop = 0);
    let titleDiv = document.createElement("h1")
    titleDiv.innerText = objTitle.innerText
    titleDiv.classList.add('titleReportIMG')
    console.log('titleDiv ', titleDiv)
    var objTableClone = objTable.parentNode.cloneNode(true)
    newDiv.append(objTableClone);
    let DivTitle = document.createElement("div");
    DivTitle.append(titleDiv);
    newDiv.append(DivTitle);
    objTableClone.style ="";
    newDiv.append(objTableClone);
    //document.body.append(newDiv);
    objTable.append(newDiv)
    var vHeight = ((objTable.scrollHeight / 2) + 50);
    newDiv.setAttribute("style","width:" + objTable.scrollWidth + "px;height:" + vHeight + "px");

    html2canvas(newDiv, {
      height: vHeight,
      width: objTable.scrollWidth,
      scale: 3,
      backgroundColor: "white",
      logging: false,
      
    }).then((canvas) => {
      var vImg = canvas.toDataURL(); 
      const a = window.document.createElement("a");
      a.href = vImg; //window.URL.createObjectURL(vImg);
      a.download = getTitle + ".jpg";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      objTable.removeChild(newDiv)
      //document.body.removeChild(newDiv);
    });
  }

  const onExport = () =>{
    ref.current && ref.current.onExport();
  }

  const onChangeTipoCambioMoneda = (value:string)=>{
    setTipoCambioMoneda(value)
  }
  
  const onVerOcultarClick = useCallback((idCentroMod: string, idPais: string, noMostrar: boolean) => {
    // alert('onMostrarOcultarClick -> ' + idCentroMod + ' ' + idPais + ' ' + noMostrar + ' : '+ año + ' - ' + periodo + ' - ' + informe + '  - ' + idCentro)
    onMostrarOcultarClick({año: año, periodo: periodo, IdTipoInforme: informe, IdCentroInforme: idCentro, IdCentro: idCentroMod, IdPais: idPais, NoMostrar: noMostrar, MonedaCorriente: tipoCambioMoneda == 'MCR', moneda: (moneda?moneda[0].value:'EUR')})
  }, [data, idCentro, informe, periodo, año, tipoCambioMoneda, moneda]);

  const onCentroOtroFormatoClick = useCallback((idCentroMod: string, idPais: string, noMostrar: boolean) => {
    onOtroFormatoClick({año: año, periodo: periodo, IdTipoInforme: informe, IdCentroInforme: idCentro, IdCentro: idCentroMod, IdPais: idPais, NoMostrar: noMostrar, MonedaCorriente: tipoCambioMoneda == 'MCR', moneda: (moneda?moneda[0].value:'EUR')})
  }, [data, idCentro, informe, periodo, año, tipoCambioMoneda, moneda]);


  const onSubirBajarNivelClick = useCallback((idCentroMod: string, centroSubido: boolean) => {
    onSubirBajarClick({año: año, periodo: periodo, IdTipoInforme: informe, IdCentroInforme: idCentro, IdCentro: idCentroMod, SubirCentro: centroSubido, MonedaCorriente: tipoCambioMoneda == 'MCR', moneda: (moneda?moneda[0].value:'EUR')})
  }, [data, idCentro, informe, periodo, año, tipoCambioMoneda, moneda]);

  const onLabelBottomButtonClick = useCallback((idPais: string, colName: string, value: boolean) => {
    onLabelBottomClick({año: año, periodo: periodo, IdTipoInforme: informe, IdCentroInforme: idCentro, IdPais: idPais, Value: value, ColName: colName});
  }, [data, idCentro, informe, periodo, año, tipoCambioMoneda, moneda]);

  const getIdCentro = useMemo(()=> idCentro,[idCentro]);

  const getViewColumns = useMemo(()=>{
    let configCols = [ocultarSuc,ocultarFil,ocultarUte,ocultarElec];
    return (informe == 'TENDVEH' || informe == 'PROPOBJVEH') ? configCols.filter((f:any)=> f.value === false).map((m:any)=> m.name) : undefined;
  },[ocultarSuc,ocultarFil,ocultarUte,ocultarElec])

  const getDataDisplay = useMemo(()=>{
    // console.log('data GRID', data);
    if(showGrid && data.length > 0){
      return(<GridResultsScreen
        data={data}
        selector={false}
        menu={false}
        ref={ref}
        informe={informe}
        onMostrarOcultarClick={(['DN_ADMON','IT','CG','DEL_CARGA'].indexOf(currentUser.perfil) >= 0 ? onVerOcultarClick : undefined)}
        verBotonMostrarOcultar={['DN_ADMON','IT','CG','DEL_CARGA'].indexOf(currentUser.perfil) >= 0}
        onSubirBajarClick={(['DN_ADMON','IT','CG','DEL_CARGA'].indexOf(currentUser.perfil) >= 0 ? onSubirBajarNivelClick : undefined)}
        onOtroFormatoClick={(['DN_ADMON','IT','CG','DEL_CARGA'].indexOf(currentUser.perfil) >= 0 ? onCentroOtroFormatoClick : undefined)}
        onLabelBottomClick={(['DN_ADMON','IT','CG','DEL_CARGA'].indexOf(currentUser.perfil) >= 0 ? onLabelBottomButtonClick : undefined)}
      />)
    }else{
      if(informe == 'GREVOL') return <GraficoInforme data={data} tipo={informe} año={año} periodo={periodo} moneda={moneda?moneda[0].value:'EUR'} showMaskWater={(!ocultarBorrador && tieneNoValidados)} showAnimation={verAnimation}/>
      else if(informe == 'GRPRPOBJ' || informe == 'GRTEND' || informe == 'GRREAL') return <GraficosBarras data={data} tipo={informe} año={año} periodo={periodo} moneda={moneda?moneda[0].value:'EUR'} showMaskWater={(!ocultarBorrador && tieneNoValidados)} showAnimation={verAnimation}/>
      else return <TablaInforme data={data} isLoading={isLoading} tipo={informe} idVersion={versionInforme} año={año} moneda={moneda?moneda[0].value:'EUR'} viewColumns = {getViewColumns} showMarkWater={!ocultarBorrador && tieneNoValidados}/>
    }
  },[showGrid,data, ocultarSuc, ocultarFil, ocultarUte, ocultarElec, ocultarBorrador, isLoading, tieneNoValidados, verAnimation])

  const getNombreCentro = () => {
    let dataFilter=[];

    dataFilter = (data && data.filter((d:any)=> d.idCentro === idCentro))

    if(dataFilter.length>0){return dataFilter[0].centro}else{return ''}
  }

  const centro = useMemo(()=> data && data[0] ?  `${idCentro} - ${getNombreCentro()}` : '',[data])

  const getTitle = useMemo(()=>{
    if(data && data.length>0){
      switch (informe) {
            case 'TENDVEH':
              return TITLESREPORT(centro,año,periodo).TENDVEH
            case 'PROPOBJVEH':
              return TITLESREPORT(centro,año,periodo).PROPOBJVEH
            case 'PROOBJTEND':
              return TITLESREPORT(centro,año,periodo).PROOBJTEND
            case 'OBJREAL':
              return TITLESREPORT(centro,año,periodo).OBJREAL
            case 'TENDOBJ':
              return TITLESREPORT(centro,año,periodo).TENDOBJ
            case 'GREVOL':
              return TITLESREPORT(centro,año,periodo).GREVOL
            case 'GRPRPOBJ':
              return TITLESREPORT(centro,año,periodo).GRPRPOBJ
            case 'GRTEND':
              return TITLESREPORT(centro,año,periodo).GRTEND
            case 'REALOBJ':
              return TITLESREPORT(centro, año, periodo).REALOBJ
            case 'GRREAL':
              return TITLESREPORT(centro, año, periodo).GRREAL
            default: return ''
      }
    }
  },[data,periodo])

  const onButtonConfigurationClick = () =>
        setOpenConfiguration((openConfiguration) => !openConfiguration);
    const closePopover = () => setOpenConfiguration(false);

  const getConfig = () =>{
   return ((informe == 'TENDVEH' || informe == 'PROPOBJVEH') && !showGrid) ?
    (
      <EuiPopover
          ownFocus={false}
          button={<EuiButtonIcon size='xs' iconType="gear" onClick={onButtonConfigurationClick} className='btnInformeConfig' />}
          isOpen={openConfiguration}
          closePopover={closePopover}
          initialFocus="[id=asdf2]">
          
          <EuiFlexGroup direction='column'>
            <EuiFlexItem><EuiSwitch label={'Ocultar Sucursal'} checked={ocultarSuc.value} onChange={(e)=>setOcultarSuc({...ocultarSuc,...{value:!ocultarSuc.value}})} /></EuiFlexItem>
            <EuiFlexItem><EuiSwitch label={'Ocultar Filial'} checked={ocultarFil.value} onChange={(e)=>setOcultarFil({...ocultarFil,...{value:!ocultarFil.value}})} /></EuiFlexItem>
            <EuiFlexItem><EuiSwitch label={'Ocultar UTE Extranjera'} checked={ocultarUte.value} onChange={(e)=>setOcultarUte({...ocultarUte,...{value:!ocultarUte.value}})} /></EuiFlexItem>
            <EuiFlexItem><EuiSwitch label={'Ocultar Elecnor Matriz'} checked={ocultarElec.value} onChange={(e)=>setOcultarElec({...ocultarElec,...{value:!ocultarElec.value}})} /></EuiFlexItem>
          </EuiFlexGroup>
          
      </EuiPopover>
    ) : null
  }

  const Actions: Action[] = useMemo(()=>[
    {handle:onExport,text:"Exportar",size:"s", isDisabled:!showGrid},
    {handle:onClickPrint, text:"Imprimir", size: "s", isDisabled: (data.length == 0 && todosInformes.length == 0) || showGrid},
    {handle:onImageDownload, text:"Descargar Imagen", size: "s", isDisabled: data.length == 0 || showGrid}
  ],[onExport, onClickPrint, onImageDownload, showGrid, data])

  return (
    <>
      <EuiFlexGroup gutterSize='none' style={{height:'100%'}} className={(toogle ? "collapsePanel collapsed" : "collapsePanel")}>
            <EuiFlexItem grow={false}>
              <EuiFlexGroup direction='column' gutterSize='s' style={{height:'100%'}}>
                <EuiFlexItem grow={false}>
                    <EuiTitle size="s"><h1>{(año !== undefined ? año + ' - ' + reunion : "No hay ningun periodo abierto.")}</h1></EuiTitle>
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                    <SelectorInformes fullWidth valueOfSelected={informe} onChange={onInformeChange} año={año} periodo={periodo} conVersion={true} MostrarTODOS={true} />
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                    <EuiPanel className={showGrid ? 'panelSwitchCheck' : 'panelSwitchUnCheck'}>
                      <EuiSwitch label={'Formato Tabla'} checked={showGrid} onChange={(e)=>setShowGrid(!showGrid)} />
                    </EuiPanel>
                </EuiFlexItem>
                {['DN_ADMON','IT','CG'].indexOf(currentUser.perfil) >= 0 && <EuiFlexItem grow={false}>
                    <EuiPanel className={ocultarBorrador ? 'panelSwitchCheck' : 'panelSwitchUnCheck'}>
                      <EuiSwitch label={`Ocultar Borrador`} checked={ocultarBorrador} onChange={(e)=>setOcultarBorrador(!ocultarBorrador)}/>
                    </EuiPanel>
                </EuiFlexItem>
                }
                <EuiFlexItem style={{overflow:'hidden'}}>
                    <SumarigramaContainer menu={true} onlySearch={true} filter={getFilter} onClickNode={onClickCentro} style={{overflow:'auto',height: '100%', border:'none'}}/>
                </EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlexItem>
            <EuiFlexItem className='tooglebtn' grow={false} onClick={onClickToogle}>
              <EuiIcon type={toogle ? "arrowRight" : "arrowLeft"} size="l" onClick={onClickToogle}/>
            </EuiFlexItem>
        <EuiFlexItem style={{height: "100%",padding: "0.2rem", overflow:"hidden", marginBottom:'5px'}}>
          <EuiFlexGroup alignItems='baseline'>
            <EuiFlexItem style={{flexGrow:0.3}}>
              <SelectorMonedas selectedOptions={moneda} onChange={(value:any) => setMoneda(value)}/> 
            </EuiFlexItem>
            <EuiFlexItem>
              <EuiFlexGroup alignItems='center'>
                <EuiFlexItem grow={false}>
                  <EuiFilterGroup>
                    <EuiFilterButton
                      grow={false}
                      hasActiveFilters={tipoCambioMoneda===_tiposMoneda[0].value}
                      onClick={()=>onChangeTipoCambioMoneda(_tiposMoneda[0].value)}>
                      {_tiposMoneda[0].label}
                    </EuiFilterButton>
                    <EuiFilterButton
                      grow={false}
                      hasActiveFilters={tipoCambioMoneda===_tiposMoneda[1].value}
                      onClick={()=>onChangeTipoCambioMoneda(_tiposMoneda[1].value)}>
                        {_tiposMoneda[1].label}
                    </EuiFilterButton>
                  </EuiFilterGroup>
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  {fnIsLoading(isLoading, sinAño)}
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  {getConfig()}
                </EuiFlexItem>
                <EuiFlexItem>
                  <Menu actions={Actions}/>
                </EuiFlexItem>
              </EuiFlexGroup>
            </EuiFlexItem>
          </EuiFlexGroup>

          <EuiFlexGroup style={{height:'90%', flexDirection:'column'}}>
            <EuiFlexItem grow={false} style={{marginBottom:'0'}}>
              <div id='AreaImprimirIMG' className='titleReport'>{getTitle}</div>
            </EuiFlexItem>
            <EuiFlexItem style={{ overflowX:'auto', overflowY:'auto'}}>
              {getDataDisplay}
            </EuiFlexItem>
          </EuiFlexGroup> 
        </EuiFlexItem>
      </EuiFlexGroup>
    </>
  );
};

export default SeleccionInformesScreen;
